import React, { useState, useMemo } from 'react';
import { v4 } from 'uuid';
import ToastContext from '../context.js';
import { findLastIndex } from '../../../../helpers/arrays/index.js';
import useTimers from '../../Hooks/useTimers/index.js';
import useStaticHandler from '../../Hooks/useStaticHandler/useStaticHandler.js';
import ToastWrapper from '../View/ToastWrapper/ToastWrapper.js';

const MAX_VISIBLE_TOASTS = 3;
const ToastProvider = _ref => {
  let {
    children
  } = _ref;
  const [toastsList, setToastsList] = useState([]);
  const {
    setAutoClearTimeout
  } = useTimers();

  /**
   * Mark toast as hidden and show next toast in queue
   */
  const hideToast = useStaticHandler(key => {
    setToastsList(prev => {
      // hide toast
      const newToasts = prev.filter(toast => toast.id !== key);

      // show next toast in queue
      const visibleToasts = newToasts.filter(toast => toast.isVisible).length;
      if (visibleToasts < MAX_VISIBLE_TOASTS) {
        const indexToShow = findLastIndex(newToasts, toast => !toast.isVisible);
        if (indexToShow !== -1) {
          const toastToShow = {
            ...newToasts[indexToShow]
          };
          // show toast
          toastToShow.isVisible = true;
          // hide toast after timeout
          setAutoClearTimeout(() => hideToast(toastToShow.id), toastToShow.timeout);
          // update toast in list
          newToasts[indexToShow] = toastToShow;
        }
      }
      return newToasts;
    });
  });
  const showToast = useStaticHandler((message, type, timeout, onClose, action) => {
    const visibleToastsCount = toastsList.filter(toast => toast.isVisible).length;
    const toast = {
      message,
      type,
      id: v4(),
      onClose,
      action,
      timeout,
      isVisible: visibleToastsCount < MAX_VISIBLE_TOASTS
    };
    setToastsList(toasts => [toast, ...toasts]);

    // if toast is visible
    if (toast.isVisible) {
      // hide toast after timeout
      setAutoClearTimeout(() => hideToast(toast.id), toast.timeout);
    }
    return toast.id;
  });
  const toastContextProviderValue = useMemo(() => ({
    showToast,
    hideToast
  }), [hideToast, showToast]);
  return /*#__PURE__*/React.createElement(ToastContext.Provider, {
    value: toastContextProviderValue
  }, children, /*#__PURE__*/React.createElement(ToastWrapper, {
    toasts: toastsList.filter(toast => toast.isVisible)
  }));
};
var ToastProvider$1 = ToastProvider;

export { ToastProvider$1 as default };
//# sourceMappingURL=ToastProvider.js.map
